<template>
  <v-container fluid style="height: 100%;" class="box" align-stretch>
    <v-layout row wrap ma-0 py-4 justify-start>
      <v-flex xs12>
        <p class="font-weight-medium my-0 mx-3 px-3">อุบัติเหตุบนโครงข่ายทางรถไฟ</p>
        <v-data-table
          :headers="accidentSRTHeader"
          :items="accidentSRTData"
          :items-per-page="10"
          :footer-props="footerProps"
          no-data-text="ไม่พบข้อมูล"
          class="no-new-line-header elevation-0 mt-4 mx-3 px-3"
          :hide-default-footer="accidentSRTData.length == 0"
          :mobile-breakpoint="0"
        >
          <template v-slot:item="props">
            <tr class="cursor" @click="goToPage(props.item.id)">
              <td class="no-new-line">{{ props.index + 1 }}</td>
              <td class="no-new-line">{{ props.item.date }}</td>
              <td class="no-new-line">{{ props.item.time }}</td>
              <td class="no-new-line">
                {{ getStationString(props.item.from_station, props.item.to_station) }}
              </td>
              <td class="no-new-line">
                {{ getTrainString(props.item.train_no, props.item.trn_start, props.item.trn_end) }}
              </td>
              <td class="no-new-line">{{ props.item.up_down || '-' }}</td>
              <td class="no-new-line">{{ props.item.km || '-' }}</td>
              <td class="no-new-line">{{ props.item.province || '-' }}</td>
              <td class="no-new-line">{{ props.item.accident_pattern || '-' }}</td>
              <td class="no-new-line">{{ props.item.surround_character || '-' }}</td>
              <td class="no-new-line">{{ props.item.dead }}</td>
              <td class="no-new-line">{{ props.item.injury }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12>
        <p class="font-weight-medium my-0 mx-3 px-3">
          อุบัติการณ์และอุบัติเหตุบนโครงข่ายรถไฟฟ้ามหานคร
        </p>
        <v-data-table
          :headers="accidentMRTHeader"
          :items="accidentMRTData"
          :items-per-page="10"
          :footer-props="footerProps"
          no-data-text="ไม่พบข้อมูล"
          class="no-new-line-header elevation-0 mt-4 mx-3 px-3"
          :hide-default-footer="accidentMRTData.length == 0"
          :mobile-breakpoint="0"
        >
          <template v-slot:item="props">
            <tr class="cursor" @click="goToPage(props.item.id)">
              <td class="no-new-line">{{ props.index + 1 }}</td>
              <td class="no-new-line">{{ props.item.date }}</td>
              <td class="no-new-line">{{ props.item.time }}</td>
              <td class="no-new-line">{{ props.item.start_linecolor || '-' }}</td>
              <td class="no-new-line">
                {{ getStationString(props.item.start_station, props.item.end_station) }}
              </td>
              <td class="no-new-line">{{ props.item.category || '-' }}</td>
              <td class="min-width-250">{{ props.item.description_incidence }}</td>
              <td class="no-new-line">{{ props.item.class_incidence }}</td>
              <td class="no-new-line">{{ props.item.cause_incidence }}</td>
              <td class="no-new-line">{{ props.item.unusual_event_type }}</td>
              <td class="no-new-line">{{ props.item.dead }}</td>
              <td class="no-new-line">{{ props.item.injury }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs12>
        <p class="font-weight-medium my-0 mx-3 px-3">
          อุบัติการณ์และอุบัติเหตุบนโครงข่ายรถไฟฟ้าแอร์พอร์ต เรล ลิงก์
        </p>
        <v-data-table
          :headers="accidentARLHeader"
          :items="accidentARLData"
          :items-per-page="10"
          :footer-props="footerProps"
          no-data-text="ไม่พบข้อมูล"
          class="no-new-line-header elevation-0 mt-4 mx-3 px-3"
          :hide-default-footer="accidentARLData.length == 0"
          :mobile-breakpoint="0"
        >
          <template v-slot:item="props">
            <tr class="cursor" @click="goToPage(props.item.id)">
              <td class="no-new-line">{{ props.index + 1 }}</td>
              <td class="no-new-line">{{ props.item.date }}</td>
              <td class="no-new-line">{{ props.item.time }}</td>
              <td class="no-new-line">{{ props.item.station || '-' }}</td>
              <td class="no-new-line">{{ props.item.spec_location }}</td>
              <td class="min-width-250">{{ props.item.phase || '-' }}</td>
              <td class="no-new-line">{{ props.item.type_incidence || '-' }}</td>
              <td class="no-new-line">{{ props.item.cause_incidence || '-' }}</td>
              <td class="no-new-line">{{ props.item.category_incidence || '-' }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'AccidentTable',
  props: {
    searchCondition: {
      type: Object
    }
  },
  data: () => ({
    footerProps: {
      // itemsPerPageOptions: [5, 10, 25, { text: 'ทั้งหมด', value: -1 }],
      itemsPerPageOptions: [],
      itemsPerPageText: 'จำนวนแถวที่แสดง',
      disableItemsPerPage: true
    },
    accidentSRTHeader: [
      { text: 'ลำดับที่', align: 'center', sortable: false, value: 'no' },
      { text: 'วันที่', align: 'center', sortable: false, value: 'date' },
      { text: 'เวลา', align: 'center', sortable: false, value: 'time' },
      {
        text: 'บริเวณที่เกิดเหตุ',
        align: 'center',
        sortable: false,
        value: 'area'
      },
      {
        text: 'ขบวน',
        align: 'center',
        sortable: false,
        value: 'rail_no'
      },
      {
        text: 'เส้นทาง',
        align: 'center',
        sortable: false,
        value: 'up_and_down'
      },
      {
        text: 'กม.',
        align: 'center',
        sortable: false,
        value: 'km'
      },
      {
        text: 'จังหวัด',
        align: 'center',
        sortable: false,
        value: 'province'
      },
      {
        text: 'ลักษณะการเกิดอุบัติเหตุ',
        align: 'center',
        sortable: false,
        value: 'accident_character'
      },
      {
        text: 'ลักษณะทาง',
        align: 'center',
        sortable: false,
        value: 'road_character'
      },
      {
        text: 'ผู้เสียชีวิต (คน)',
        align: 'center',
        sortable: false,
        value: 'dead'
      },
      {
        text: 'ผู้บาดเจ็บ (คน)',
        align: 'center',
        sortable: false,
        value: 'injury'
      }
    ],
    accidentSRTData: [],
    accidentMRTHeader: [
      { text: 'ลำดับที่', align: 'center', sortable: false, value: 'no' },
      { text: 'วันที่', align: 'center', sortable: false, value: 'date' },
      { text: 'เวลา', align: 'center', sortable: false, value: 'time' },
      {
        text: 'โครงการ',
        align: 'center',
        sortable: false,
        value: 'project'
      },
      {
        text: 'สถานที่',
        align: 'center',
        sortable: false,
        value: 'area'
      },
      {
        text: 'อุบัติการณ์/อุบัติเหตุ',
        align: 'center',
        sortable: false,
        value: 'accident_incident'
      },
      {
        text: 'ประเภทของอุบัติเหตุ',
        align: 'center',
        sortable: false,
        value: 'accident_type'
      },
      {
        text: 'ระดับของเหตุการณ์',
        align: 'center',
        sortable: false,
        value: 'severity'
      },
      {
        text: 'สาเหตุ',
        align: 'center',
        sortable: false,
        value: 'cause'
      },
      {
        text: 'ลักษณะของอุบัติการณ์',
        align: 'center',
        sortable: false,
        value: 'incident_character'
      },
      {
        text: 'ผู้เสียชีวิต (คน)',
        align: 'center',
        sortable: false,
        value: 'dead'
      },
      {
        text: 'ผู้บาดเจ็บ (คน)',
        align: 'center',
        sortable: false,
        value: 'injury'
      }
    ],
    accidentARLHeader: [
      { text: 'ลำดับที่', align: 'center', sortable: false, value: 'no' },
      { text: 'วันที่', align: 'center', sortable: false, value: 'date' },
      { text: 'เวลา', align: 'center', sortable: false, value: 'time' },
      {
        text: 'สถานี',
        align: 'center',
        sortable: false,
        value: 'station'
      },
      {
        text: 'บริเวณ',
        align: 'center',
        sortable: false,
        value: 'spec_location'
      },
      {
        text: 'ช่วงเวลา',
        align: 'center',
        sortable: false,
        value: 'phase'
      },
      {
        text: 'ประเภทของอุบัติเหตุ',
        align: 'center',
        sortable: false,
        value: 'type_incidence'
      },
      {
        text: 'สาเหตุ',
        align: 'center',
        sortable: false,
        value: 'cause_incidence'
      },
      {
        text: 'ลักษณะของอุบัติการณ์',
        align: 'center',
        sortable: false,
        value: 'category_incidence'
      }
    ],
    accidentMRTData: [],
    accidentARLData: []
  }),
  mounted() {},
  methods: {
    search() {
      this.getRail();
      this.getMetro();
      this.getAirportLink();
    },
    getRail() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/srt_accident`;
      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.accidentSRTData = response.data.data;
          }
        })
        .catch(function(error) {
          scope.accidentSRTData = [];
          console.log(error);
        });
    },
    getMetro() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/mrt_accident`;
      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.accidentMRTData = response.data.data;
          }
        })
        .catch(function(error) {
          scope.accidentMRTData = [];
          console.log(error);
        });
    },
    getAirportLink() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/arl_accident`;
      this.axios
        .get(url, { params: this.searchCondition })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.accidentARLData = response.data.data;
          }
        })
        .catch(function(error) {
          scope.accidentARLData = [];
          console.log(error);
        });
    },
    getStationString(from, to) {
      if (from == null && to == null) return '-';
      if ((from == null && to != null) || from == to) return to;
      if (from != null && to == null) return from;
      return `ช่วง ${from} ถึง ${to}`;
    },
    getTrainString(train, from, to) {
      if (train == null) return '-';
      if (from == null || to == null) return train;
      return `${train} (${from} ถึง ${to})`;
    },
    goToPage(id) {
      if (id != null) {
        const routeData = this.$router.resolve({ name: 'report_detail', query: { data: id } });
        window.open(routeData.href, '_blank');
      }
    }
  },
  computed: {},
  watch: {
    searchCondition() {
      this.search();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.col {
  padding: 0;
}

.v-tab {
  background-color: white;
  color: #ba4438;
}
.min-width-250 {
  min-width: 250px;
}
</style>
